import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { VideoSignedURL, List, ListParams} from '../types/main';
import { ItemId, Video } from '../types/items';
import { MediaFormVideo } from '../types/formItems';
import { transformList } from './transformer';

class VideoService {
  private route = apis.video;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api
    .get<List<Video>>(this.route.list, params)
    .then(transformList);

  get = (id: ItemId) => this.api.get<Video>(`${this.route.list}/${id}`);

  template = () => this.api.get<Video>(`${this.route.list}/new`);

  save = (id: ItemId, video: Video | MediaFormVideo) => this.api.put(`${this.route.list}/${id}`, video);

  create = ({
    id, ref, permissions, ...video
  }: Video) => this.api.post<Video>(this.route.list, video);

  delete = (id: ItemId) => this.api.delete(`${this.route.list}/${id}`);

  uploadUrl = (id: ItemId) =>
    this.api.get<VideoSignedURL>(`${this.route.list}/${id}/upload-url`,{cors_origin: window.location.origin});

  downloadUrl = (id: ItemId) =>
    this.api.get<VideoSignedURL>(`${this.route.list}/${id}/download-urls`,{cors_origin: window.location.origin});

  sync = (id: ItemId) => this.api.put<Video>(`${this.route.list}/${id}/sync`,{cors_origin: window.location.origin});

}

export default new VideoService(apiService);
